import React, { Component } from 'react';

class Icons extends Component {
    render() {
        return (
           <p className="service-icons">
                <i className="fab fa-aws" data-toggle="tooltip"  data-placement="bottom" title="AWS"></i>
                <i className="fab fa-android" data-toggle="tooltip"  data-placement="bottom" title="Android Development"></i> 
                <i className="fab fa-bluetooth" data-toggle="tooltip"  data-placement="bottom" title="Bluetooth Application Development"></i> 
                <i className="fab fa-angular" data-toggle="tooltip"  data-placement="bottom" title="Angular Development"></i> 
                <i className="fab fa-chrome" data-toggle="tooltip"  data-placement="bottom" title="Chrome Extension Development"></i> 
                <i className="fab fa-js" data-toggle="tooltip"  data-placement="bottom" title="Javascript Development"></i> 
                <i className="fab fa-java" data-toggle="tooltip"  data-placement="bottom" title="Java Development"  ></i> 
                <i className="fab fa-php" data-toggle="tooltip"  data-placement="bottom" title="PHP Development"></i>
                <i className="fab fa-cpanel" data-toggle="tooltip"  data-placement="bottom" title="Cpanel Administration"></i> 
                <i className="fab fa-css3-alt" data-toggle="tooltip"  data-placement="bottom" title="CSS3 Development"></i> 
                <i className="fab fa-freebsd" data-toggle="tooltip"  data-placement="bottom" title="FreeBSD Server Hosting"></i> 
                <i className="fab fa-python" data-toggle="tooltip"  data-placement="bottom" title="Python Development"></i>
                <i className="fab fa-wordpress" data-toggle="tooltip"  data-placement="bottom" title="Wordpress Development"></i> 
                <i className="fab fa-linux" data-toggle="tooltip"  data-placement="bottom" title="Linux Administration and Development"></i>
                <i className="fab fa-react" data-toggle="tooltip"  data-placement="bottom" title="ReactJS and React Native Development"></i>
                <i className="fab fa-html5" data-toggle="tooltip"  data-placement="bottom" title="HTML5 Development"></i>
            </p>
        );
    }
}

export default Icons;



// WEBPACK FOOTER //
// ./src/components/Icons.js